import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { fmtMese } from "@/lib/api";

const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export const MonthPicker = ({ value, onChange, className = "h-8 w-44", allowClear = false, placeholder = "Tutti i mesi", testId = "month-picker" }) => {
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(() => parseInt((value || "").slice(0, 4)) || new Date().getFullYear());
  const pick = (v) => { onChange(v); setOpen(false); };
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o && value) setYear(parseInt(value.slice(0, 4))); }}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className={`${className} justify-start gap-2 font-normal`} data-testid={testId}>
          <CalendarDays className="w-4 h-4 opacity-70" />
          <span className="truncate">{value ? fmtMese(value) : placeholder}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="start" data-testid={`${testId}-popover`}>
        <div className="flex items-center justify-between mb-2">
          <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => setYear(year - 1)} data-testid={`${testId}-prev-year`}><ChevronLeft className="w-4 h-4" /></Button>
          <span className="font-heading font-bold" data-testid={`${testId}-year`}>{year}</span>
          <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => setYear(year + 1)} data-testid={`${testId}-next-year`}><ChevronRight className="w-4 h-4" /></Button>
        </div>
        <div className="grid grid-cols-3 gap-1">
          {MESI.map((m, i) => {
            const v = `${year}-${String(i + 1).padStart(2, "0")}`;
            const active = v === value;
            return (
              <Button key={m} size="sm" variant={active ? "default" : "ghost"}
                      className={`h-8 ${!active && v === today ? "ring-1 ring-primary" : ""}`}
                      onClick={() => pick(v)} data-testid={`${testId}-month-${i + 1}`}>{m}</Button>
            );
          })}
        </div>
        <div className="flex justify-between mt-2 pt-2 border-t">
          <Button size="sm" variant="link" className="h-6 px-1" onClick={() => pick(today)} data-testid={`${testId}-today`}>Mese corrente</Button>
          {allowClear && <Button size="sm" variant="link" className="h-6 px-1" onClick={() => pick("")} data-testid={`${testId}-clear`}>Tutti</Button>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
